import { TimeslotMonth, timeslotsStore } from 'entities/timeslots';
import { FC, Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { PreloaderWrapper, withPreloader } from 'shared/ui/preloader';
import { formatWithLocale, mappingDaysToMonths } from 'shared/lib/date';
import { observer } from 'mobx-react-lite';
import { bookingStore } from 'entities/booking';
import { doctorsStore } from 'features/doctors';
import { IDay } from './types';
import { ScheduleFeedLoader } from './scheduleFeedLoader';
import styles from './styles.module.scss';
import { useParams } from 'react-router-dom';
import { ScheduleFeedMonth } from '../scheduleFeedMonth/scheduleFeedMonth';


const ScheduleWithPreloader = withPreloader(
	PreloaderWrapper,
	false,
	ScheduleFeedLoader,
);
interface ScheduleFeedListProps {
	selectDay: (day: IDay) => void;
}
export const ScheduleFeedList: FC<ScheduleFeedListProps> = observer(
	({ selectDay }) => {
		const [days, setDays] = useState<IDay[]>([]);
		const bookingDateRef = useRef('');
    const { id } = useParams();

		const fetchBookingDataAndSetByDate = useCallback(async (date: string) => {
			bookingDateRef.current = date;
			bookingStore.setDate(date);
			timeslotsStore.fetchSlotsByDoctors(date, id);
			await doctorsStore.fetchDoctors(date);
		}, [id, bookingDateRef])

    const getActiveDay = (days?: TimeslotMonth[]) => {
      if (!days) return null;

      const dateFromLocalStorage = localStorage.getItem('date');
      const now = formatWithLocale(new Date(), 'yyyy-MM-dd');

      if (dateFromLocalStorage) {
        const finded = days.find(el => el.date === dateFromLocalStorage);
        if (finded&&finded.has_slots) return dateFromLocalStorage;
      };
      
      const nowFinded = days.find(el => el.date === now);
      if (nowFinded&&nowFinded.has_slots) return now;

      const first = days.find(el => el.has_slots === true);

      return first?.date;
    }

		useEffect(() => {
			const setMonthsList = async () => {
        if (!localStorage.getItem('specialization')) {
          return setTimeout(() => {
            setMonthsList();
          }, 500);
        }
				const monthsRes = await timeslotsStore.fetchMonths(id);
				// const bookingDate = localStorage.getItem('date') || monthsRes?.at(0)?.date || formatWithLocale(new Date(), 'yyyy-MM-dd');
				const bookingDate = getActiveDay(monthsRes);
				if (bookingDate) {
					fetchBookingDataAndSetByDate(bookingDate);
				}

				if (monthsRes&&!days.length) {
					setDays(
						monthsRes.map(month => {
							const obj = { ...month, isActive: false };

							if (month.date === bookingDate) {
								obj.isActive = true;
								selectDay(obj);
							}

							return obj;
						}),
					);
				}
			};
			setMonthsList();
      // eslint-disable-next-line
		}, [selectDay, days]);

		const changeDayActive = useCallback(
			async (date: string) => {
				if (date) {
					bookingDateRef.current = date;
					await fetchBookingDataAndSetByDate(date);
					const cloneDays = Array.from(days);
					cloneDays.map((day, index) => {
						if (day.date === date) {
							const dayObj = { ...day, isActive: true };
							cloneDays[index] = dayObj;
							selectDay(dayObj);
						} else {
							cloneDays[index] = { ...day, isActive: false };
						}
					});

					setDays(cloneDays);
				}
			},
			[setDays, selectDay, days, fetchBookingDataAndSetByDate],
		);

		useEffect(() => {
			if (bookingStore.date !== bookingDateRef.current) {
				changeDayActive(bookingStore.date);
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [bookingStore.date, changeDayActive]);

    const months = useMemo(() => {
      return mappingDaysToMonths(days);
    }, [days])

		return (
			<Fragment>
				<ScheduleWithPreloader
					isLoading={timeslotsStore.loadingMonthsSlots}
					error={timeslotsStore.errorMonthsSlots}
				>
					<div className={styles['schedule-feed-list']}>
            {months.map((month, index) => (
              <ScheduleFeedMonth 
                key={index}
                month={month}
                changeDayActive={changeDayActive}
              />
            ))}
					</div>
				</ScheduleWithPreloader>
			</Fragment>
		);
	},
);
